if (!customElements.get('pdp-selling-plan-select')) {
  class PdpSellingPlanSelect extends HTMLElement {
    constructor() {
      super();
      this.oneTime = this.querySelector('#one-time-purchase');
      this.subscriptionCheckbox = this.querySelector('#selling-plan-select');
      this.options = this.querySelectorAll('.selling-plan-option');
      this.selectOption = this.selectOption.bind(this);
      this.sellingPlan = this.querySelector('#selling_plan_select');
      this.selectFields = this.querySelectorAll('select');
      this.sellingPlanPrice = this.querySelector('.selling-plan-selling-price');
    }

    connectedCallback() {
      const id = this.id;
      const container =
        this.closest('.subscription-content-container') || this.closest('product-info') || this.parentElement;
      if (this.closest('.subscription-content-container')) {
        this.hiddenSellingPlanInput = this.closest('.subscription-content-container').querySelector('#selling_plan');
        if (this.sellingPlan) this.hiddenSellingPlanInput.value = this.sellingPlan.value;
      } else {
        this.hiddenSellingPlanInput = this.closest('product-info').querySelector('#selling_plan');
      }
      this.options.forEach((option) => {
        option.addEventListener('click', this.selectOption);
      });

      this.selectFields.forEach((select) => {
        select.addEventListener('change', (e) => {
          const selectedOption = select.options[select.selectedIndex];
          const price = selectedOption.dataset.optionPrice;
          if (this.sellingPlanPrice) this.sellingPlanPrice.innerHTML = price;
        });
      });
    }

    selectOption(e) {
      const container = e.target.closest('.selling-plan-option');
      if (!container) return;

      this.querySelector('.option-selected')?.classList.remove('option-selected');
      container.classList.add('option-selected');
      const childInput = container.querySelector('input');

      // Uncheck all radio inputs first
      this.querySelectorAll('input[type="radio"]').forEach((input) => {
        input.checked = false;
      });

      // Set the new radio input as checked
      childInput.checked = true;

      // Trigger change event on the radio input
      childInput.dispatchEvent(new Event('change', { bubbles: true }));

      if (childInput.id == 'selling-plan-select') {
        if (this.sellingPlan) this.sellingPlan.disabled = false;

        if (this.hiddenSellingPlanInput) {
          if (this.sellingPlan) this.hiddenSellingPlanInput.value = this.sellingPlan.value;
          this.hiddenSellingPlanInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      } else {
        if (this.sellingPlan) this.sellingPlan.disabled = true;

        if (this.hiddenSellingPlanInput) {
          this.hiddenSellingPlanInput.value = '';
          this.hiddenSellingPlanInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }
  }

  customElements.define('pdp-selling-plan-select', PdpSellingPlanSelect);
}
